import API from "../lib/api";

export const getAllFeatures = async () => {
  try {
    const response = await API.get("acl/features");
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createFeature = async (data) => {
  try {
    const response = await API.post("acl/features", data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteFeature = async (id) => {
  try {
    const response = await API.delete(`acl/features/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
export const updateFeature = async (id, data) => {
  try {
    const response = await API.put(`acl/features/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};